import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { MottagningsplatsModule } from "~app/features/forsaljning/mottagningsplats/mottagningsplats.module";
import { DetailsComponent } from "./handelssortiment/details/details.component";
import { HeaderComponent } from "./handelssortiment/details/header/header.component";
import { HsProduktComponent } from "./handelssortiment/details/hs-produkt/hs-produkt.component";
import { ProduktRadComponent } from "./handelssortiment/details/hs-produkt/produkt-rad/produkt-rad.component";
import { MatningComponent } from "./handelssortiment/details/matning/matning.component";
import { SortimentComponent } from "./handelssortiment/details/sortiment/sortiment.component";
import { HandelssortimentComponent } from "./handelssortiment/handelssortiment.component";
import { HandelssortimentService } from "./handelssortiment/handelssortiment.service";
import { HandelssortimentSearchService } from "./handelssortiment/search-panel/handelssortiment-search.service";
import { SearchPanelComponent } from "./handelssortiment/search-panel/search-panel.component";
import { SearchResultComponent } from "./handelssortiment/search-result/search-result.component";
import { KundDetailsModalBefraktarstyrningComponent } from "./kund/components/kund-details-modal/befraktarstyrning/kund-details-modal-befraktarstyrning.component";
import { KundDetailsModalComponent } from "./kund/components/kund-details-modal/kund-details-modal.component";
import { KundListComponent } from "./kund/components/kund-list/kund-list.component";
import { KundComponent } from "./kund/kund.component";
import { CreateKundorderModalComponent } from "./kundorder/create-kundorder-modal/create-kundorder-modal.component";
import { KundorderDetailsComponent } from "./kundorder/kundorder-details/kundorder-details.component";
import { KundorderradCommentComponent } from "./kundorder/kundorder-details/kundorderrad-comment/kundorderrad-comment.component";
import { KundorderradCreateComponent } from "./kundorder/kundorder-details/kundorderrad-create/kundorderrad-create.component";
import { KorForsorjningsradCreateComponent } from "./kundorder/kundorder-details/kundorderrad-details/kor-forsorjningsrad-create/kor-forsorjningsrad-create.component";
import { KorForsorjningsradEditComponent } from "./kundorder/kundorder-details/kundorderrad-details/kor-forsorjningsrad-edit/kor-forsorjningsrad-edit.component";
import { ForsorjningskallaCellComponent } from "./kundorder/kundorder-details/kundorderrad-details/kor-hot/forsorjningskalla-cell/forsorjningskalla-cell.component";
import { KorHotComponent } from "./kundorder/kundorder-details/kundorderrad-details/kor-hot/kor-hot.component";
import { KundorderradDetailsComponent } from "./kundorder/kundorder-details/kundorderrad-details/kundorderrad-details.component";
import { AlternativaHandelssortimentComponent } from "./kundorder/kundorder-details/kundorderrad-edit/alternativa-handelssortiment/alternativa-handelssortiment.component";
import { AlternativaMottagningsplatserComponent } from "./kundorder/kundorder-details/kundorderrad-edit/alternativa-mottagningsplatser/alternativa-mottagningsplatser.component";
import { KundorderradEditComponent } from "./kundorder/kundorder-details/kundorderrad-edit/kundorderrad-edit.component";
import { KundorderradHandelssortimentComponent } from "./kundorder/kundorder-details/kundorderrad-edit/kundorderrad-handelssortiment/kundorderrad-handelssortiment.component";

import { CkleverantorComponent } from "./ckleverator/ckleverantor.component";

import { CkleverantorDetailsDialogComponent } from "./ckleverator/components/ckleverantor-details-dialog/ckleverantor-details-dialog.component";
import { CkleverantorListComponent } from "./ckleverator/components/ckleverantor-list/ckleverantor-list.component";
import { HandelssortimentFileDownloaderComponent } from "./handelssortiment/handelssortiment-file-downloader/handelssortiment-file-downloader.component";

import {
    KundorderradInmatningshandelssortimentComponent
} from "./kundorder/kundorder-details/kundorderrad-edit/kundorderrad-inmatningshandelssortiment/kundorderrad-inmatningshandelssortiment.component";
import { KundorderradMottagningsplatserComponent } from "./kundorder/kundorder-details/kundorderrad-edit/kundorderrad-mottagningsplatser/kundorderrad-mottagningsplatser.component";
import { KundorderListComponent } from "./kundorder/kundorder-list/kundorder-list.component";
import { KundorderComponent } from "./kundorder/kundorder.component";
import { KundorderService } from "./kundorder/kundorder.service";
import { LeverantorsorderListComponent } from "./leverantorsorder/components/leverantorsorder-list/leverantorsorder-list.component";
import { CopyLeverantorsorderHeaderComponent } from "./leverantorsorder/copy-order/copy-leverantorsorder-header/copy-leverantorsorder-header.component";
import { CopyLeverantorsorderComponent } from "./leverantorsorder/copy-order/copy-leverantorsorder.component";
import { CreateLeverantorsorderModalComponent } from "./leverantorsorder/create-leverantorsorder-modal/create-leverantorsorder-modal.component";
import { LeveransraderCreateComponent } from "./leverantorsorder/leveransrader-create/leveransrader-create.component";
import { LeveransraderEditComponent } from "./leverantorsorder/leveransrader-edit/leveransrader-edit.component";
import { CreateLeverantorsorderradModalComponent } from "./leverantorsorder/leverantorsorder-details/create-leverantorsorderrad-modal/create-leverantorsorderrad-modal.component";
import { LeverantorsorderDetailsComponent } from "./leverantorsorder/leverantorsorder-details/leverantorsorder-details.component";
import { LeverantorsorderHeaderComponent } from "./leverantorsorder/leverantorsorder-details/leverantorsorder-header/leverantorsorder-header.component";
import { LeverantorsorderLeveransraderComponent } from "./leverantorsorder/leverantorsorder-details/leverantorsorder-leveransrader/leverantorsorder-leveransrader.component";
import { LeverantorsorderradCreateComponent } from "./leverantorsorder/leverantorsorder-details/leverantorsorderrad-create/leverantorsorderrad-create.component";
import { LeverantorsorderradEditComponent } from "./leverantorsorder/leverantorsorder-details/leverantorsorderrad-edit/leverantorsorderrad-edit.component";
import { LeverantorsorderComponent } from "./leverantorsorder/leverantorsorder.component";
import { LeverantorsorderService } from "./leverantorsorder/services/leverantorsorder.service";
import { CopyOrderHeaderComponent } from "./order/copy-order/copy-order-header/copy-order-header.component";
import { CopyOrderComponent } from "./order/copy-order/copy-order.component";
import { CreateOrderradModalComponent } from "./order/create-orderrad-modal/create-orderrad-modal.component";
import { OrderHeaderComponent } from "./order/order-details/order-header/order-header.component";
import { OrderService } from "./order/order.service";
import { ProduktModule } from "./produkt/produkt.module";
import { ProduktService } from "./produkt/produkt.service";
import { TerminalorderDetailsComponent } from "./terminalorder/terminalorder-details/terminalorder-details.component";
import { TerminalorderListComponent } from "./terminalorder/terminalorder-list/terminalorder-list.component";
import { TerminalorderComponent } from "./terminalorder/terminalorder.component";
import { TerminalorderService } from "./terminalorder/terminalorder.service";

@NgModule({
    imports: [
        RaskCommonModule,
        MottagningsplatsModule,
        ProduktModule,
        HandelssortimentComponent,
        HeaderComponent,
        MatningComponent,
        SearchPanelComponent,
        SearchResultComponent,
        DetailsComponent,
        ProduktRadComponent,
        SortimentComponent,
        HsProduktComponent,
        KundorderComponent,
        KundorderListComponent,
        TerminalorderComponent,
        TerminalorderListComponent,
        KundComponent,
        KundListComponent,
        LeverantorsorderComponent,
        LeverantorsorderListComponent,
        KundorderDetailsComponent,
        KundorderradCreateComponent,
        KundorderradDetailsComponent,
        KorForsorjningsradCreateComponent,
        KorHotComponent,
        KorForsorjningsradEditComponent,
        KundorderradEditComponent,
        AlternativaHandelssortimentComponent,
        KundorderradInmatningshandelssortimentComponent,
        AlternativaMottagningsplatserComponent,
        KundorderradHandelssortimentComponent,
        KundorderradMottagningsplatserComponent,
        OrderHeaderComponent,
        TerminalorderDetailsComponent,
        LeverantorsorderDetailsComponent,
        LeverantorsorderHeaderComponent,
        LeverantorsorderradEditComponent,
        LeverantorsorderradCreateComponent,
        LeverantorsorderLeveransraderComponent,
        KundDetailsModalComponent,
        LeveransraderEditComponent,
        LeveransraderCreateComponent,
        CreateKundorderModalComponent,
        CreateOrderradModalComponent,
        CreateLeverantorsorderModalComponent,
        CreateLeverantorsorderradModalComponent,
        KundDetailsModalBefraktarstyrningComponent,
        CopyOrderComponent,
        CopyOrderHeaderComponent,
        CopyLeverantorsorderComponent,
        CopyLeverantorsorderHeaderComponent,
        KundorderradCommentComponent,
        ForsorjningskallaCellComponent,
        CkleverantorComponent,
        CkleverantorListComponent,
        CkleverantorDetailsDialogComponent,
        HandelssortimentFileDownloaderComponent
    ],
    providers: [
        HandelssortimentSearchService,
        KundorderService,
        ProduktService,
        TerminalorderService,
        LeverantorsorderService,
        OrderService,
        HandelssortimentService
    ]
})
export class ForsaljningModule { }
